import { useEffect } from 'react';
import { useCoreClient } from '@hooks';
import {
  givzFeaturedOrganizationsState,
  notificationErrorState,
  organizationsLoadingState,
} from '@states';
import { useRecoilState } from 'recoil';
import * as Sentry from '@sentry/browser';

const requestFailedMessage = 'Error fetching Givz default featured charities';

export const useFetchGivzFeaturedOrganizations = () => {
  const [givzFeaturedOrganizations, setGivzFeaturedOrganizations] =
    useRecoilState(givzFeaturedOrganizationsState);
  const [, setNotificationError] = useRecoilState(notificationErrorState);
  const [organizationsLoading, setOrganizationsLoading] = useRecoilState(
    organizationsLoadingState,
  );

  const coreClient = useCoreClient();

  useEffect(() => {
    const fetchFeaturedOrganizations = async () => {
      setOrganizationsLoading(true);

      const { data, errors } = await coreClient().Collections.getCurated({
        key: 'GIVZ_MONTHLY',
      });

      setOrganizationsLoading(false);

      if (errors) {
        setNotificationError(errors);
      } else {
        if (data.organizations.length === 0) {
          setNotificationError(requestFailedMessage);
          Sentry.captureMessage(
            'Givz default featured charities returned empty',
          );
          return;
        }

        setGivzFeaturedOrganizations(data);
      }
    };

    fetchFeaturedOrganizations();
  }, [
    coreClient,
    setGivzFeaturedOrganizations,
    setNotificationError,
    setOrganizationsLoading,
  ]);

  return {
    givzCuratedOrganizationsCollectionGid: givzFeaturedOrganizations?.gid,
    organizationsLoading,
    setOrganizationsLoading,
  };
};
